'use client';

import { formatSecondsTime } from '@/utils';
import { Slider } from '@nextui-org/react';
import clsx from 'clsx';
import Image from 'next/image';

import { MindfulAudioImg } from '@/config/img/mindfulAudio';
import { useClientTranslation } from '@/hook/translate';

export default function MobileAudioBar(props: {
  url: string;
  className?: string;
  play: () => void;
  pause: () => void;
  duration: number;
  currentTime: number;
  changeCurrentTime: (value: number) => void;
  audioStatus: string;
}) {
  const {
    play,
    pause,
    duration,
    audioStatus,
    currentTime,
    changeCurrentTime,
  } = props;
  const { t } = useClientTranslation();

  function imageLoader({ src }: { src: string }) {
    return src;
  }

  return (
   <div>
    <div className='flex items-center justify-center pt-12'>
      <div 
        className='flex items-center bg-[#155FF9] rounded-full h-14 pl-[5px] cursor-pointer'
        onClick={() => {
          if (audioStatus === 'play') {
            pause();
          } else {
            play();
          }
        }}
        >
      {
        audioStatus === 'play' ?
          <Image alt='stop' loader={imageLoader} src={ MindfulAudioImg.StopBookey }  className='cursor-pointer' width={ 46 } height={ 46 } />
          :
          <Image alt='play' loader={imageLoader} src={ MindfulAudioImg.PlayBookey }  className='cursor-pointer' width={ 46 } height={ 46 }  />
      }
      <span className='text-white font-bold text-16-22 pl-[10px] pr-5'>{ t('playSample', 'mindfulAudio') }</span>
      </div>
    </div>
     <div className={
      clsx('audio-wrap flex pr-5 mt-6 items-center  rounded-[45px]', props?.className)
    }>
      
      <span onClick={pause} className='pl-2 pr-1'>{ formatSecondsTime(currentTime) }</span>
      <Slider
        size="sm"
        step={1}
        maxValue={duration}
        hideThumb={true}
        minValue={0}
        value={currentTime}
        onChange={(value) => changeCurrentTime(value as number)}
        aria-label="audio"
        className='pl-[10px] flex-1'
        classNames={{
          filler: 'bg-[#CDF564]',
          track: '!border-0 bg-white',
        }}
      />
      <span onClick={pause} className='pl-2'>{ formatSecondsTime(duration) }</span>
    </div>
   </div>
  );
}
